<!--
 * @Author: liuqing
 * @Date: 2021-01-30 10:21:53
 * @LastEditors: sunbingqing
 * @LastEditTime: 2022-03-28 15:12:01
 * @Description: 确认弹窗
 * @Copyright: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <transition name="confirm-fade">
    <div class="confirm-modal-mask" v-show="visible">
      <div class="confirm-modal">
        <div class="confirm-modal-header">{{ title }}</div>
        <div class="confirm-modal-body">
          <slot></slot>
        </div>
        <div class="confirm-modal-footer">
          <div class="cancel-btn" @click="onCancel">{{ cancelText }}</div>
          <div class="ok-btn" @click="onOk">{{ okText }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CommonConfirm",

  props: {
    title: {
      type: String,
      default: ""
    },

    cancelText: {
      type: String,
      default: "取消"
    },

    okText: {
      type: String,
      default: "确定"
    },

    visible: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    visible(val) {
      if (val) {
        document.body.appendChild(this.$el);
      } else {
      }
    }
  },

  data() {
    return {};
  },

  methods: {
    onCancel() {
      this.$emit("update:visible", false);
    },
    onOk() {
      this.$emit("update:visible", false);
      this.$emit("ok");
    }
  },

  mounted() {
    if (this.visible) {
      document.body.appendChild(this.$el);
    }
  },

  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
};
</script>

<style lang="less" scoped>
@keyframes confirm-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes confirm-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.confirm-fade-enter-active {
  animation: confirm-fade-in .4s;
}

.confirm-fade-leave-active {
  animation: confirm-fade-out .4s;
}
.confirm-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1111;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  .confirm-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 0.24rem;
    transform: translate(-50%, -50%);
    width: 70%;
    max-height: 70%;
    background-color: #fff;
    .confirm-modal-body {
      max-height: 50vh;
      min-height: 0.32rem;
      overflow-y: auto;
      line-height: 0.32rem;
      padding: 0.18rem 0.3rem 0.3rem;
      font-size: 0.26rem;
      color: #030303;
      margin: 0.2rem 0;
    }
    .confirm-modal-header {
      text-align: center;
      margin-top: 0.48rem;
      font-weight: 500;
      font-size: 0.34rem;
      color: #030303;
    }
    .confirm-modal-footer {
      position: relative;
      padding-top: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .cancel-btn, .ok-btn {
        flex: 1;
        text-align: center;
        height: 0.86rem;
        font-size: 0.34rem;
        color: #0076ff;
      }
      .cancel-btn {
        position: relative;
        &::after {
          position: absolute;
          top: 0;
          right: 0;
          content: '';
          width: 1px;
          height: 98%;
          background-color: #eee;
          transform-origin: 0 0;
          transform: scaleX(0.5);
        }
      }
      &::before {
        position: absolute;
        top: 0;
        right: 0;
        content: '';
        width: 100%;
        height: 1px;
        background-color: #eee;
        transform-origin: 0 0;
        transform: scaleY(0.5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonConfirm.vue